<template>
  <div v-show="isActive">
    <div class="alert alert-warning" role="alert">
      {{ $t('messages.no_data') }}
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex'

export default{
  computed: {
    ...mapGetters('noData', [
      'isActive'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/NoData.vue